import React from 'react';
import { FacebookLink, TwitterLink, InstagramLink } from './Social-Link';
import { Copyright, OrdersLink } from './Footer-Links';
import './Footer.css';
import SectionSeparator from "./Section-Separator";

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const footer = () => {
    return (
        <footer className="footer">
            <SectionSeparator />
            <Container>
                <Row className="justify-content-center">
                    <Col xs="auto"><FacebookLink /></Col>
                    <Col xs="auto"><InstagramLink /></Col>
                    <Col xs="auto"><TwitterLink /></Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Copyright className="text-sm-left tbc-footer-text" />
                    </Col>
                    <Col md={6}>
                        <OrdersLink className="text-sm-right tbc-footer-text" />
                    </Col>
                </Row>
            </Container>
        </footer>
    )
};
export default footer;